"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const x_data_grid_1 = require("@mui/x-data-grid");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const react_router_1 = require("react-router");
const strings_1 = require("../../../../constants/strings");
const codingQuery_1 = require("../../../../queries/codingQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const zustandStore_1 = require("../../../../zustandStore");
const useTeamsState_1 = require("../../../pages/teamSettings/overview/hooks/useTeamsState");
const codingHeaderSection_1 = __importDefault(require("./codingHeaderSection"));
const useColumns_1 = require("./useColumns");
const useGetTableAdditionRowEditable_1 = require("./useGetTableAdditionRowEditable");
const useGetTableData_1 = require("./useGetTableData");
const CodingListTable = ({ roleId }) => {
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: codingLists, isFetching } = (0, react_query_1.useQuery)({
        ...(0, codingQuery_1.getCodingListsQuery)({ skipDisabled: true }),
        ...(initialData && 'codingLists' in initialData && { initialData: initialData.codingLists }),
    });
    const { data: codingEntries } = (0, react_query_1.useQuery)({
        ...(0, codingQuery_1.getCodingListsEntriesQuery)({ codingLists }),
        ...(initialData && 'codingEntries' in initialData && { initialData: initialData.codingEntries }),
    });
    const { data: teams } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.teamsQuery)({ state: 'active' }),
        ...(initialData && 'teams' in initialData && { initialData: initialData.teams }),
    });
    const { setPageLoading } = (0, zustandStore_1.useZustand)();
    const columns = (0, useColumns_1.useColumns)(roleId);
    const state = (0, useTeamsState_1.useTeamsState)();
    const theme = (0, material_1.useTheme)();
    const [page, setPage] = (0, react_1.useState)(1);
    const LIMIT = 10; // we usually set 10 per page
    const startIndex = (page - 1) * LIMIT;
    const endIndex = startIndex + LIMIT;
    const selectedCodingEntriesData = state.selectedCodingEntries.values.slice(startIndex, endIndex);
    const totalCount = state.selectedCodingEntries.values.length || 0;
    const getTableAdditionRowEditable = (0, useGetTableAdditionRowEditable_1.useGetTableAdditionRowEditable)({
        teams,
    });
    const [tableData, isMutationInProgress] = (0, useGetTableData_1.useGetTableData)({ selectedCodingEntries: selectedCodingEntriesData });
    const apiRef = (0, x_data_grid_1.useGridApiRef)();
    (0, react_1.useEffect)(() => {
        if (!apiRef.current) {
            return;
        }
        const handleCellClick = (params) => {
            if (!params.isEditable || params.cellMode !== 'view') {
                return;
            }
            apiRef.current?.startCellEditMode({
                id: params.id,
                field: params.field,
            });
        };
        if (apiRef.current && typeof apiRef.current.subscribeEvent === 'function') {
            apiRef.current.subscribeEvent('cellClick', handleCellClick);
        }
    }, [apiRef]);
    (0, react_1.useEffect)(() => {
        if (!codingEntries || codingEntries.length === 0) {
            return;
        }
        const selectedCodingEntries = codingEntries.find(entry => entry.code === state.currentCodingListSelected.id);
        if (!selectedCodingEntries) {
            return;
        }
        state.setSelectedCodingEntries(selectedCodingEntries);
    }, [codingEntries, state.currentCodingListSelected]);
    (0, react_1.useEffect)(() => {
        setPageLoading(false);
    }, [setPageLoading]);
    const totalPages = Math.ceil(totalCount / LIMIT);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: Array.isArray(codingLists) && codingLists.length === 0 ? ((0, jsx_runtime_1.jsxs)(material_1.Grid, { "data-testid": "no-coding-list", container: true, direction: "column", sx: {
                justifyContent: 'center',
                alignItems: 'center',
            }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": "no-list-info", children: strings_1.companySettingsCodingStrings.NO_CODING_TEXT }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": "no-list-info", children: strings_1.companySettingsCodingStrings.NO_CODING_SUB_TEXT })] })) : ((0, jsx_runtime_1.jsxs)(material_1.Paper, { variant: "outlined", "ts-variant": "modal", children: [(0, jsx_runtime_1.jsx)(codingHeaderSection_1.default, {}), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { display: 'flex', flexDirection: 'column', minWidth: '650px' }, children: [(0, jsx_runtime_1.jsx)(x_data_grid_1.DataGrid, { apiRef: apiRef, initialState: {
                                columns: {
                                    columnVisibilityModel: {
                                        rowActions: roleId !== 'team_admin',
                                    },
                                },
                            }, className: "codingListTable", columns: columns, rows: roleId === 'team_admin' ? tableData : [getTableAdditionRowEditable, ...tableData], disableColumnMenu: true, hideFooter: true, loading: isFetching || isMutationInProgress, onCellClick: (_params, event) => {
                                event.defaultMuiPrevented = true;
                            } }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                paddingTop: theme.tsGoUnit.tsUnitHalf,
                                paddingBottom: theme.tsGoUnit.tsUnitHalf,
                            }, children: (0, jsx_runtime_1.jsx)(material_1.Pagination, { count: totalPages, page: page, onChange: (_, newPage) => {
                                    setPage(newPage);
                                }, showFirstButton: true, showLastButton: true, color: "primary" }) })] })] })) }));
};
exports.default = CodingListTable;
